import { useState } from 'react'
import React from 'react'
import axios from 'axios'
import moment from 'moment'
import './fgi.css'; // 引用全局样式文件

export default function FearGreed() {
  const [data, setData] = useState({})
  const fetchData = async () => {
    try {
      const result = await axios(`coin/index`);
      setData(result.data.data[0])
    } catch (error) {
      console.log(error)
    }
  };
  React.useEffect(() => {
    fetchData();
    setInterval(() => {
      fetchData();
    }, 60 * 1000);
  }, []);
  return (
    <div className='container text-center'>
      <div className="orange font-lg margin-top-lg">{ data.value }</div>
      {data.timestamp && <div className="gray margin-top-xs">{moment(data.timestamp * 1000).format('YYYY-MM-DD')} { `(${((data.time_until_update / 60 / 60).toFixed(1))} h)` }</div>}
    </div>
  )
}